import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/JointROM"
import { invokeSetAddJointROMAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
//import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class JointROMForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       //this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getJointROMAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var right_1st_toe_flexion                = results.data[0].right_1st_toe_flexion;
                var right_1st_toe_extension              = results.data[0].right_1st_toe_extension;
                var right_ankle_dorsiflexion             = results.data[0].right_ankle_dorsiflexion;
                var right_ankle_plantarflexion           = results.data[0].right_ankle_plantarflexion;
                var right_ankle_eversion                 = results.data[0].right_ankle_eversion;
                var right_ankle_inversion                = results.data[0].right_ankle_inversion;
                var right_knee_extension                 = results.data[0].right_knee_extension;
                var right_knee_flexion                   = results.data[0].right_knee_flexion;
                var right_hip_extension                  = results.data[0].right_hip_extension;
                var right_hip_flexion                    = results.data[0].right_hip_flexion;
                var right_hip_abduction                  = results.data[0].right_hip_abduction;
                var right_hip_adduction                  = results.data[0].right_hip_adduction;
                var right_glenohumeral_flexion           = results.data[0].right_glenohumeral_flexion;
                var right_glenohumeral_extension         = results.data[0].right_glenohumeral_extension;
                var right_glenohumeral_abduction         = results.data[0].right_glenohumeral_abduction;
                var right_glenohumeral_internal_rotation = results.data[0].right_glenohumeral_internal_rotation;
                var right_glenohumeral_external_rotation = results.data[0].right_glenohumeral_external_rotation;
                var right_elbow_flexion                  = results.data[0].right_elbow_flexion;
                var right_elbow_extension                = results.data[0].right_elbow_extension;
                var right_wrist_flexion                  = results.data[0].right_wrist_flexion;
                var right_wrist_extension                = results.data[0].right_wrist_extension;
                var right_wrist_radial_deviation         = results.data[0].right_wrist_radial_deviation;
                var right_wrist_ulnar_deviation          = results.data[0].right_wrist_ulnar_deviation;
                var right_thumb_flexion                  = results.data[0].right_thumb_flexion;
                var right_thumb_extension                = results.data[0].right_thumb_extension;
                var right_thumb_abduction                = results.data[0].right_thumb_abduction;
                var right_thumb_adduction                = results.data[0].right_thumb_adduction;

                var left_1st_toe_flexion                = results.data[0].left_1st_toe_flexion;
                var left_1st_toe_extension              = results.data[0].left_1st_toe_extension;
                var left_ankle_dorsiflexion             = results.data[0].left_ankle_dorsiflexion;
                var left_ankle_plantarflexion           = results.data[0].left_ankle_plantarflexion;
                var left_ankle_eversion                 = results.data[0].left_ankle_eversion;
                var left_ankle_inversion                = results.data[0].left_ankle_inversion;
                var left_knee_extension                 = results.data[0].left_knee_extension;
                var left_knee_flexion                   = results.data[0].left_knee_flexion;
                var left_hip_extension                  = results.data[0].left_hip_extension;
                var left_hip_flexion                    = results.data[0].left_hip_flexion;
                var left_hip_abduction                  = results.data[0].left_hip_abduction;
                var left_hip_adduction                  = results.data[0].left_hip_adduction;
                var left_glenohumeral_flexion           = results.data[0].left_glenohumeral_flexion;
                var left_glenohumeral_extension         = results.data[0].left_glenohumeral_extension;
                var left_glenohumeral_abduction         = results.data[0].left_glenohumeral_abduction;
                var left_glenohumeral_internal_rotation = results.data[0].left_glenohumeral_internal_rotation;
                var left_glenohumeral_external_rotation = results.data[0].left_glenohumeral_external_rotation;
                var left_elbow_flexion                  = results.data[0].left_elbow_flexion;
                var left_elbow_extension                = results.data[0].left_elbow_extension;
                var left_wrist_flexion                  = results.data[0].left_wrist_flexion;
                var left_wrist_extension                = results.data[0].left_wrist_extension;
                var left_wrist_radial_deviation         = results.data[0].left_wrist_radial_deviation;
                var left_wrist_ulnar_deviation          = results.data[0].left_wrist_ulnar_deviation;
                var left_thumb_flexion                  = results.data[0].left_thumb_flexion;
                var left_thumb_extension                = results.data[0].left_thumb_extension;
                var left_thumb_abduction                = results.data[0].left_thumb_abduction;
                var left_thumb_adduction                = results.data[0].left_thumb_adduction;

                var left_hip_internal_rotation          = results.data[0].left_hip_internal_rotation;
                var right_hip_internal_rotation         = results.data[0].right_hip_internal_rotation;
                var left_hip_external_rotation          = results.data[0].left_hip_external_rotation;
                var right_hip_external_rotation         = results.data[0].right_hip_external_rotation;


                this.setState({
                    userFormData: {
                        right_1st_toe_flexion:                  right_1st_toe_flexion,
                        right_1st_toe_extension:                right_1st_toe_extension,
                        right_ankle_dorsiflexion:               right_ankle_dorsiflexion,
                        right_ankle_plantarflexion:             right_ankle_plantarflexion,
                        right_ankle_eversion:                   right_ankle_eversion,
                        right_ankle_inversion:                  right_ankle_inversion,
                        right_knee_extension:                   right_knee_extension,
                        right_knee_flexion:                     right_knee_flexion,
                        right_hip_extension:                    right_hip_extension,
                        right_hip_flexion:                      right_hip_flexion,
                        right_hip_abduction:                    right_hip_abduction,
                        right_hip_adduction:                    right_hip_adduction,
                        right_glenohumeral_flexion:             right_glenohumeral_flexion,
                        right_glenohumeral_extension:           right_glenohumeral_extension,
                        right_glenohumeral_abduction:           right_glenohumeral_abduction,
                        right_glenohumeral_internal_rotation:   right_glenohumeral_internal_rotation,
                        right_glenohumeral_external_rotation:   right_glenohumeral_external_rotation,
                        right_elbow_flexion:                    right_elbow_flexion,
                        right_elbow_extension:                  right_elbow_extension,
                        right_wrist_flexion:                    right_wrist_flexion,
                        right_wrist_extension:                  right_wrist_extension,
                        right_wrist_radial_deviation:           right_wrist_radial_deviation,
                        right_wrist_ulnar_deviation:            right_wrist_ulnar_deviation,
                        right_thumb_flexion:                    right_thumb_flexion,
                        right_thumb_extension:                  right_thumb_extension,
                        right_thumb_abduction:                  right_thumb_abduction,
                        right_thumb_adduction:                  right_thumb_adduction,

                        left_1st_toe_flexion:                  left_1st_toe_flexion,
                        left_1st_toe_extension:                left_1st_toe_extension,
                        left_ankle_dorsiflexion:               left_ankle_dorsiflexion,
                        left_ankle_plantarflexion:             left_ankle_plantarflexion,
                        left_ankle_eversion:                   left_ankle_eversion,
                        left_ankle_inversion:                  left_ankle_inversion,
                        left_knee_extension:                   left_knee_extension,
                        left_knee_flexion:                     left_knee_flexion,
                        left_hip_extension:                    left_hip_extension,
                        left_hip_flexion:                      left_hip_flexion,
                        left_hip_abduction:                    left_hip_abduction,
                        left_hip_adduction:                    left_hip_adduction,
                        left_glenohumeral_flexion:             left_glenohumeral_flexion,
                        left_glenohumeral_extension:           left_glenohumeral_extension,
                        left_glenohumeral_abduction:           left_glenohumeral_abduction,
                        left_glenohumeral_internal_rotation:   left_glenohumeral_internal_rotation,
                        left_glenohumeral_external_rotation:   left_glenohumeral_external_rotation,
                        left_elbow_flexion:                    left_elbow_flexion,
                        left_elbow_extension:                  left_elbow_extension,
                        left_wrist_flexion:                    left_wrist_flexion,
                        left_wrist_extension:                  left_wrist_extension,
                        left_wrist_radial_deviation:           left_wrist_radial_deviation,
                        left_wrist_ulnar_deviation:            left_wrist_ulnar_deviation,
                        left_thumb_flexion:                    left_thumb_flexion,
                        left_thumb_extension:                  left_thumb_extension,
                        left_thumb_abduction:                  left_thumb_abduction,
                        left_thumb_adduction:                  left_thumb_adduction,

                        left_hip_internal_rotation:            left_hip_internal_rotation,
                        right_hip_internal_rotation:           right_hip_internal_rotation,
                        left_hip_external_rotation:            left_hip_external_rotation,
                        right_hip_external_rotation:           right_hip_external_rotation
                    }
                });
            }
            //this.setUserFormData();
        } else {
            //this.setUserFormData();
        }
    }

    setUserFormData(right_1st_toe_flexion, right_1st_toe_extension, right_ankle_dorsiflexion, right_ankle_plantarflexion, right_ankle_eversion, right_ankle_inversion, right_knee_extension, right_knee_flexion, right_hip_extension, right_hip_flexion, right_hip_abduction, right_hip_adduction, right_glenohumeral_flexion, right_glenohumeral_extension, right_glenohumeral_abduction, right_glenohumeral_internal_rotation, right_glenohumeral_external_rotation, right_elbow_flexion, right_elbow_extension, right_wrist_flexion, right_wrist_extension, right_wrist_radial_deviation, right_wrist_ulnar_deviation, right_thumb_flexion, right_thumb_extension, right_thumb_abduction, right_thumb_adduction, left_1st_toe_flexion, left_1st_toe_extension, left_ankle_dorsiflexion, left_ankle_plantarflexion, left_ankle_eversion, left_ankle_inversion, left_knee_extension, left_knee_flexion, left_hip_extension, left_hip_flexion, left_hip_abduction, left_hip_adduction, left_glenohumeral_flexion, left_glenohumeral_extension, left_glenohumeral_abduction, left_glenohumeral_internal_rotation, left_glenohumeral_external_rotation, left_elbow_flexion, left_elbow_extension, left_wrist_flexion, left_wrist_extension, left_wrist_radial_deviation, left_wrist_ulnar_deviation, left_thumb_flexion, left_thumb_extension, left_thumb_abduction, left_thumb_adduction, left_hip_internal_rotation, right_hip_internal_rotation, left_hip_external_rotation, right_hip_external_rotation) {
        this.setState({
            userFormData: {
                right_1st_toe_flexion                : right_1st_toe_flexion,
                right_1st_toe_extension              : right_1st_toe_extension,
                right_ankle_dorsiflexion             : right_ankle_dorsiflexion,
                right_ankle_plantarflexion           : right_ankle_plantarflexion,
                right_ankle_eversion                 : right_ankle_eversion,
                right_ankle_inversion                : right_ankle_inversion,
                right_knee_extension                 : right_knee_extension,
                right_knee_flexion                   : right_knee_flexion,
                right_hip_extension                  : right_hip_extension,
                right_hip_flexion                    : right_hip_flexion,
                right_hip_abduction                  : right_hip_abduction,
                right_hip_adduction                  : right_hip_adduction,
                right_glenohumeral_flexion           : right_glenohumeral_flexion,
                right_glenohumeral_extension         : right_glenohumeral_extension,
                right_glenohumeral_abduction         : right_glenohumeral_abduction,
                right_glenohumeral_internal_rotation : right_glenohumeral_internal_rotation,
                right_glenohumeral_external_rotation : right_glenohumeral_external_rotation,
                right_elbow_flexion                  : right_elbow_flexion,
                right_elbow_extension                : right_elbow_extension,
                right_wrist_flexion                  : right_wrist_flexion,
                right_wrist_extension                : right_wrist_extension,
                right_wrist_radial_deviation         : right_wrist_radial_deviation,
                right_wrist_ulnar_deviation          : right_wrist_ulnar_deviation,
                right_thumb_flexion                  : right_thumb_flexion,
                right_thumb_extension                : right_thumb_extension,
                right_thumb_abduction                : right_thumb_abduction,
                right_thumb_adduction                : right_thumb_adduction,

                left_1st_toe_flexion                : left_1st_toe_flexion,
                left_1st_toe_extension              : left_1st_toe_extension,
                left_ankle_dorsiflexion             : left_ankle_dorsiflexion,
                left_ankle_plantarflexion           : left_ankle_plantarflexion,
                left_ankle_eversion                 : left_ankle_eversion,
                left_ankle_inversion                : left_ankle_inversion,
                left_knee_extension                 : left_knee_extension,
                left_knee_flexion                   : left_knee_flexion,
                left_hip_extension                  : left_hip_extension,
                left_hip_flexion                    : left_hip_flexion,
                left_hip_abduction                  : left_hip_abduction,
                left_hip_adduction                  : left_hip_adduction,
                left_glenohumeral_flexion           : left_glenohumeral_flexion,
                left_glenohumeral_extension         : left_glenohumeral_extension,
                left_glenohumeral_abduction         : left_glenohumeral_abduction,
                left_glenohumeral_internal_rotation : left_glenohumeral_internal_rotation,
                left_glenohumeral_external_rotation : left_glenohumeral_external_rotation,
                left_elbow_flexion                  : left_elbow_flexion,
                left_elbow_extension                : left_elbow_extension,
                left_wrist_flexion                  : left_wrist_flexion,
                left_wrist_extension                : left_wrist_extension,
                left_wrist_radial_deviation         : left_wrist_radial_deviation,
                left_wrist_ulnar_deviation          : left_wrist_ulnar_deviation,
                left_thumb_flexion                  : left_thumb_flexion,
                left_thumb_extension                : left_thumb_extension,
                left_thumb_abduction                : left_thumb_abduction,
                left_thumb_adduction                : left_thumb_adduction,

                left_hip_internal_rotation:           left_hip_internal_rotation,
                right_hip_internal_rotation:          right_hip_internal_rotation,
                left_hip_external_rotation:           left_hip_external_rotation,
                right_hip_external_rotation:          right_hip_external_rotation
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {

        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 9; // joint rom is #9 in dropdown

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var right_1st_toe_flexion                = obj.right_1st_toe_flexion;
        var right_1st_toe_extension              = obj.right_1st_toe_extension;
        var right_ankle_dorsiflexion             = obj.right_ankle_dorsiflexion;
        var right_ankle_plantarflexion           = obj.right_ankle_plantarflexion;
        var right_ankle_eversion                 = obj.right_ankle_eversion;
        var right_ankle_inversion                = obj.right_ankle_inversion;
        var right_knee_extension                 = obj.right_knee_extension;
        var right_knee_flexion                   = obj.right_knee_flexion;
        var right_hip_extension                  = obj.right_hip_extension;
        var right_hip_flexion                    = obj.right_hip_flexion;
        var right_hip_abduction                  = obj.right_hip_abduction;
        var right_hip_adduction                  = obj.right_hip_adduction;
        var right_glenohumeral_flexion           = obj.right_glenohumeral_flexion;
        var right_glenohumeral_extension         = obj.right_glenohumeral_extension;
        var right_glenohumeral_abduction         = obj.right_glenohumeral_abduction;
        var right_glenohumeral_internal_rotation = obj.right_glenohumeral_internal_rotation;
        var right_glenohumeral_external_rotation = obj.right_glenohumeral_external_rotation;
        var right_elbow_flexion                  = obj.right_elbow_flexion;
        var right_elbow_extension                = obj.right_elbow_extension;
        var right_wrist_flexion                  = obj.right_wrist_flexion;
        var right_wrist_extension                = obj.right_wrist_extension;
        var right_wrist_radial_deviation         = obj.right_wrist_radial_deviation;
        var right_wrist_ulnar_deviation          = obj.right_wrist_ulnar_deviation;
        var right_thumb_flexion                  = obj.right_thumb_flexion;
        var right_thumb_extension                = obj.right_thumb_extension;
        var right_thumb_abduction                = obj.right_thumb_abduction;
        var right_thumb_adduction                = obj.right_thumb_adduction;

        var left_1st_toe_flexion                = obj.left_1st_toe_flexion;
        var left_1st_toe_extension              = obj.left_1st_toe_extension;
        var left_ankle_dorsiflexion             = obj.left_ankle_dorsiflexion;
        var left_ankle_plantarflexion           = obj.left_ankle_plantarflexion;
        var left_ankle_eversion                 = obj.left_ankle_eversion;
        var left_ankle_inversion                = obj.left_ankle_inversion;
        var left_knee_extension                 = obj.left_knee_extension;
        var left_knee_flexion                   = obj.left_knee_flexion;
        var left_hip_extension                  = obj.left_hip_extension;
        var left_hip_flexion                    = obj.left_hip_flexion;
        var left_hip_abduction                  = obj.left_hip_abduction;
        var left_hip_adduction                  = obj.left_hip_adduction;
        var left_glenohumeral_flexion           = obj.left_glenohumeral_flexion;
        var left_glenohumeral_extension         = obj.left_glenohumeral_extension;
        var left_glenohumeral_abduction         = obj.left_glenohumeral_abduction;
        var left_glenohumeral_internal_rotation = obj.left_glenohumeral_internal_rotation;
        var left_glenohumeral_external_rotation = obj.left_glenohumeral_external_rotation;
        var left_elbow_flexion                  = obj.left_elbow_flexion;
        var left_elbow_extension                = obj.left_elbow_extension;
        var left_wrist_flexion                  = obj.left_wrist_flexion;
        var left_wrist_extension                = obj.left_wrist_extension;
        var left_wrist_radial_deviation         = obj.left_wrist_radial_deviation;
        var left_wrist_ulnar_deviation          = obj.left_wrist_ulnar_deviation;
        var left_thumb_flexion                  = obj.left_thumb_flexion;
        var left_thumb_extension                = obj.left_thumb_extension;
        var left_thumb_abduction                = obj.left_thumb_abduction;
        var left_thumb_adduction                = obj.left_thumb_adduction;

        var left_hip_internal_rotation          = obj.left_hip_internal_rotation;
        var right_hip_internal_rotation         = obj.right_hip_internal_rotation;
        var left_hip_external_rotation          = obj.left_hip_external_rotation;
        var right_hip_external_rotation         = obj.right_hip_external_rotation;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddJointROMAssessment(action, assessment_id, client_id, right_1st_toe_flexion, right_1st_toe_extension, right_ankle_dorsiflexion, right_ankle_plantarflexion, right_ankle_eversion, right_ankle_inversion, right_knee_extension, right_knee_flexion, right_hip_extension, right_hip_flexion, right_hip_abduction, right_hip_adduction, right_glenohumeral_flexion, right_glenohumeral_extension, right_glenohumeral_abduction, right_glenohumeral_internal_rotation, right_glenohumeral_external_rotation, right_elbow_flexion, right_elbow_extension, right_wrist_flexion, right_wrist_extension, right_wrist_radial_deviation, right_wrist_ulnar_deviation, right_thumb_flexion, right_thumb_extension, right_thumb_abduction, right_thumb_adduction, left_1st_toe_flexion, left_1st_toe_extension, left_ankle_dorsiflexion, left_ankle_plantarflexion, left_ankle_eversion, left_ankle_inversion, left_knee_extension, left_knee_flexion, left_hip_extension, left_hip_flexion, left_hip_abduction, left_hip_adduction, left_glenohumeral_flexion, left_glenohumeral_extension, left_glenohumeral_abduction, left_glenohumeral_internal_rotation, left_glenohumeral_external_rotation, left_elbow_flexion, left_elbow_extension, left_wrist_flexion, left_wrist_extension, left_wrist_radial_deviation, left_wrist_ulnar_deviation, left_thumb_flexion, left_thumb_extension, left_thumb_abduction, left_thumb_adduction, left_hip_internal_rotation, right_hip_internal_rotation, left_hip_external_rotation, right_hip_external_rotation)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    getObjectData = (formData) => {
        var right_1st_toe_flexion;
        var right_1st_toe_extension;
        var right_ankle_dorsiflexion;
        var right_ankle_plantarflexion;
        var right_ankle_eversion;
        var right_ankle_inversion;
        var right_knee_extension;
        var right_knee_flexion;
        var right_hip_extension;
        var right_hip_flexion;
        var right_hip_abduction;
        var right_hip_adduction;
        var right_glenohumeral_flexion;
        var right_glenohumeral_extension;
        var right_glenohumeral_abduction;
        var right_glenohumeral_internal_rotation;
        var right_glenohumeral_external_rotation;
        var right_elbow_flexion;
        var right_elbow_extension;
        var right_wrist_flexion;
        var right_wrist_extension;
        var right_wrist_radial_deviation;
        var right_wrist_ulnar_deviation;
        var right_thumb_flexion;
        var right_thumb_extension;
        var right_thumb_abduction;
        var right_thumb_adduction;

        var left_1st_toe_flexion;
        var left_1st_toe_extension;
        var left_ankle_dorsiflexion;
        var left_ankle_plantarflexion;
        var left_ankle_eversion;
        var left_ankle_inversion;
        var left_knee_extension;
        var left_knee_flexion;
        var left_hip_extension;
        var left_hip_flexion;
        var left_hip_abduction;
        var left_hip_adduction;
        var left_glenohumeral_flexion;
        var left_glenohumeral_extension;
        var left_glenohumeral_abduction;
        var left_glenohumeral_internal_rotation;
        var left_glenohumeral_external_rotation;
        var left_elbow_flexion;
        var left_elbow_extension;
        var left_wrist_flexion;
        var left_wrist_extension;
        var left_wrist_radial_deviation;
        var left_wrist_ulnar_deviation;
        var left_thumb_flexion;
        var left_thumb_extension;
        var left_thumb_abduction;
        var left_thumb_adduction;
        var left_hip_internal_rotation;
        var right_hip_internal_rotation;
        var left_hip_external_rotation;
        var right_hip_external_rotation;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                //console.log("> key2: " + key2);
                //console.log("> formData2: " + data);

                if(key2 === "right_1st_toe_flexion" && this.isObject(data) == false) {
                    right_1st_toe_flexion = data;
                } else if(key2 === "right_1st_toe_extension" && this.isObject(data) == false) {
                    right_1st_toe_extension = data;
                } else if(key2 === "right_ankle_dorsiflexion" && this.isObject(data) == false) {
                    right_ankle_dorsiflexion = data;
                } else if(key2 === "right_ankle_plantarflexion" && this.isObject(data) == false) {
                    right_ankle_plantarflexion = data;
                } else if(key2 === "right_ankle_eversion" && this.isObject(data) == false) {
                    right_ankle_eversion = data;
                } else if(key2 === "right_ankle_inversion" && this.isObject(data) == false) {
                    right_ankle_inversion = data;
                } else if(key2 === "right_knee_extension" && this.isObject(data) == false) {
                    right_knee_extension = data;
                } else if(key2 === "right_knee_flexion" && this.isObject(data) == false) {
                    right_knee_flexion = data;
                } else if(key2 === "right_hip_extension" && this.isObject(data) == false) {
                    right_hip_extension = data;
                } else if(key2 === "right_hip_flexion" && this.isObject(data) == false) {
                    right_hip_flexion = data;
                } else if(key2 === "right_hip_abduction" && this.isObject(data) == false) {
                    right_hip_abduction = data;
                } else if(key2 === "right_hip_adduction" && this.isObject(data) == false) {
                    right_hip_adduction = data;
                } else if(key2 === "right_glenohumeral_flexion" && this.isObject(data) == false) {
                    right_glenohumeral_flexion = data;
                } else if(key2 === "right_glenohumeral_extension" && this.isObject(data) == false) {
                    right_glenohumeral_extension = data;
                } else if(key2 === "right_glenohumeral_abduction" && this.isObject(data) == false) {
                    right_glenohumeral_abduction = data;
                } else if(key2 === "right_glenohumeral_internal_rotation" && this.isObject(data) == false) {
                    right_glenohumeral_internal_rotation = data;
                } else if(key2 === "right_glenohumeral_external_rotation" && this.isObject(data) == false) {
                    right_glenohumeral_external_rotation = data;
                } else if(key2 === "right_elbow_flexion" && this.isObject(data) == false) {
                    right_elbow_flexion = data;
                } else if(key2 === "right_elbow_extension" && this.isObject(data) == false) {
                    right_elbow_extension = data;
                } else if(key2 === "right_wrist_flexion" && this.isObject(data) == false) {
                    right_wrist_flexion = data;
                } else if(key2 === "right_wrist_extension" && this.isObject(data) == false) {
                    right_wrist_extension = data;
                } else if(key2 === "right_wrist_radial_deviation" && this.isObject(data) == false) {
                    right_wrist_radial_deviation = data;
                } else if(key2 === "right_wrist_ulnar_deviation" && this.isObject(data) == false) {
                    right_wrist_ulnar_deviation = data;
                } else if(key2 === "right_thumb_flexion" && this.isObject(data) == false) {
                    right_thumb_flexion = data;
                } else if(key2 === "right_thumb_extension" && this.isObject(data) == false) {
                    right_thumb_extension = data;
                } else if(key2 === "right_thumb_abduction" && this.isObject(data) == false) {
                    right_thumb_abduction = data;
                } else if(key2 === "right_thumb_adduction" && this.isObject(data) == false) {
                    right_thumb_adduction = data;
                }

                 else if(key2 === "left_1st_toe_flexion" && this.isObject(data) == false) {
                     left_1st_toe_flexion = data;
                 } else if(key2 === "left_1st_toe_extension" && this.isObject(data) == false) {
                     left_1st_toe_extension = data;
                 } else if(key2 === "left_ankle_dorsiflexion" && this.isObject(data) == false) {
                     left_ankle_dorsiflexion = data;
                 } else if(key2 === "left_ankle_plantarflexion" && this.isObject(data) == false) {
                     left_ankle_plantarflexion = data;
                 } else if(key2 === "left_ankle_eversion" && this.isObject(data) == false) {
                     left_ankle_eversion = data;
                 } else if(key2 === "left_ankle_inversion" && this.isObject(data) == false) {
                     left_ankle_inversion = data;
                 } else if(key2 === "left_knee_extension" && this.isObject(data) == false) {
                     left_knee_extension = data;
                 } else if(key2 === "left_knee_flexion" && this.isObject(data) == false) {
                     left_knee_flexion = data;
                 } else if(key2 === "left_hip_extension" && this.isObject(data) == false) {
                     left_hip_extension = data;
                 } else if(key2 === "left_hip_flexion" && this.isObject(data) == false) {
                     left_hip_flexion = data;
                 } else if(key2 === "left_hip_abduction" && this.isObject(data) == false) {
                     left_hip_abduction = data;
                 } else if(key2 === "left_hip_adduction" && this.isObject(data) == false) {
                     left_hip_adduction = data;
                 } else if(key2 === "left_glenohumeral_flexion" && this.isObject(data) == false) {
                     left_glenohumeral_flexion = data;
                 } else if(key2 === "left_glenohumeral_extension" && this.isObject(data) == false) {
                     left_glenohumeral_extension = data;
                 } else if(key2 === "left_glenohumeral_abduction" && this.isObject(data) == false) {
                     left_glenohumeral_abduction = data;
                 } else if(key2 === "left_glenohumeral_internal_rotation" && this.isObject(data) == false) {
                     left_glenohumeral_internal_rotation = data;
                 } else if(key2 === "left_glenohumeral_external_rotation" && this.isObject(data) == false) {
                     left_glenohumeral_external_rotation = data;
                 } else if(key2 === "left_elbow_flexion" && this.isObject(data) == false) {
                     left_elbow_flexion = data;
                 } else if(key2 === "left_elbow_extension" && this.isObject(data) == false) {
                     left_elbow_extension = data;
                 } else if(key2 === "left_wrist_flexion" && this.isObject(data) == false) {
                     left_wrist_flexion = data;
                 } else if(key2 === "left_wrist_extension" && this.isObject(data) == false) {
                     left_wrist_extension = data;
                 } else if(key2 === "left_wrist_radial_deviation" && this.isObject(data) == false) {
                     left_wrist_radial_deviation = data;
                 } else if(key2 === "left_wrist_ulnar_deviation" && this.isObject(data) == false) {
                     left_wrist_ulnar_deviation = data;
                 } else if(key2 === "left_thumb_flexion" && this.isObject(data) == false) {
                     left_thumb_flexion = data;
                 } else if(key2 === "left_thumb_extension" && this.isObject(data) == false) {
                     left_thumb_extension = data;
                 } else if(key2 === "left_thumb_abduction" && this.isObject(data) == false) {
                     left_thumb_abduction = data;
                 } else if(key2 === "left_thumb_adduction" && this.isObject(data) == false) {
                     left_thumb_adduction = data;
                 } else if(key2 === "left_hip_internal_rotation" && this.isObject(data) == false) {
                     left_hip_internal_rotation = data;
                 } else if(key2 === "right_hip_internal_rotation" && this.isObject(data) == false) {
                     right_hip_internal_rotation = data;
                 } else if(key2 === "left_hip_external_rotation" && this.isObject(data) == false) {
                     left_hip_external_rotation = data;
                 } else if(key2 === "right_hip_external_rotation" && this.isObject(data) == false) {
                     right_hip_external_rotation = data;
                 }
            }
        }

        var obj = {};
        obj.right_1st_toe_flexion                = right_1st_toe_flexion;
        obj.right_1st_toe_extension              = right_1st_toe_extension;
        obj.right_ankle_dorsiflexion             = right_ankle_dorsiflexion;
        obj.right_ankle_plantarflexion           = right_ankle_plantarflexion;
        obj.right_ankle_eversion                 = right_ankle_eversion;
        obj.right_ankle_inversion                = right_ankle_inversion;
        obj.right_knee_extension                 = right_knee_extension;
        obj.right_knee_flexion                   = right_knee_flexion;
        obj.right_hip_extension                  = right_hip_extension;
        obj.right_hip_flexion                    = right_hip_flexion;
        obj.right_hip_abduction                  = right_hip_abduction;
        obj.right_hip_adduction                  = right_hip_adduction;
        obj.right_glenohumeral_flexion           = right_glenohumeral_flexion;
        obj.right_glenohumeral_extension         = right_glenohumeral_extension;
        obj.right_glenohumeral_abduction         = right_glenohumeral_abduction;
        obj.right_glenohumeral_internal_rotation = right_glenohumeral_internal_rotation;
        obj.right_glenohumeral_external_rotation = right_glenohumeral_external_rotation;
        obj.right_elbow_flexion                  = right_elbow_flexion;
        obj.right_elbow_extension                = right_elbow_extension;
        obj.right_wrist_flexion                  = right_wrist_flexion;
        obj.right_wrist_extension                = right_wrist_extension;
        obj.right_wrist_radial_deviation         = right_wrist_radial_deviation;
        obj.right_wrist_ulnar_deviation          = right_wrist_ulnar_deviation;
        obj.right_thumb_flexion                  = right_thumb_flexion;
        obj.right_thumb_extension                = right_thumb_extension;
        obj.right_thumb_abduction                = right_thumb_abduction;
        obj.right_thumb_adduction                = right_thumb_adduction;

        obj.left_1st_toe_flexion                = left_1st_toe_flexion;
        obj.left_1st_toe_extension              = left_1st_toe_extension;
        obj.left_ankle_dorsiflexion             = left_ankle_dorsiflexion;
        obj.left_ankle_plantarflexion           = left_ankle_plantarflexion;
        obj.left_ankle_eversion                 = left_ankle_eversion;
        obj.left_ankle_inversion                = left_ankle_inversion;
        obj.left_knee_extension                 = left_knee_extension;
        obj.left_knee_flexion                   = left_knee_flexion;
        obj.left_hip_extension                  = left_hip_extension;
        obj.left_hip_flexion                    = left_hip_flexion;
        obj.left_hip_abduction                  = left_hip_abduction;
        obj.left_hip_adduction                  = left_hip_adduction;
        obj.left_glenohumeral_flexion           = left_glenohumeral_flexion;
        obj.left_glenohumeral_extension         = left_glenohumeral_extension;
        obj.left_glenohumeral_abduction         = left_glenohumeral_abduction;
        obj.left_glenohumeral_internal_rotation = left_glenohumeral_internal_rotation;
        obj.left_glenohumeral_external_rotation = left_glenohumeral_external_rotation;
        obj.left_elbow_flexion                  = left_elbow_flexion;
        obj.left_elbow_extension                = left_elbow_extension;
        obj.left_wrist_flexion                  = left_wrist_flexion;
        obj.left_wrist_extension                = left_wrist_extension;
        obj.left_wrist_radial_deviation         = left_wrist_radial_deviation;
        obj.left_wrist_ulnar_deviation          = left_wrist_ulnar_deviation;
        obj.left_thumb_flexion                  = left_thumb_flexion;
        obj.left_thumb_extension                = left_thumb_extension;
        obj.left_thumb_abduction                = left_thumb_abduction;
        obj.left_thumb_adduction                = left_thumb_adduction;

        obj.left_hip_internal_rotation          = left_hip_internal_rotation;
        obj.right_hip_internal_rotation         = right_hip_internal_rotation;
        obj.left_hip_external_rotation          = left_hip_external_rotation;
        obj.right_hip_external_rotation         = right_hip_external_rotation;

        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var right_1st_toe_flexion                = obj.right_1st_toe_flexion;
        var right_1st_toe_extension              = obj.right_1st_toe_extension;
        var right_ankle_dorsiflexion             = obj.right_ankle_dorsiflexion;
        var right_ankle_plantarflexion           = obj.right_ankle_plantarflexion;
        var right_ankle_eversion                 = obj.right_ankle_eversion;
        var right_ankle_inversion                = obj.right_ankle_inversion;
        var right_knee_extension                 = obj.right_knee_extension;
        var right_knee_flexion                   = obj.right_knee_flexion;
        var right_hip_extension                  = obj.right_hip_extension;
        var right_hip_flexion                    = obj.right_hip_flexion;
        var right_hip_abduction                  = obj.right_hip_abduction;
        var right_hip_adduction                  = obj.right_hip_adduction;
        var right_glenohumeral_flexion           = obj.right_glenohumeral_flexion;
        var right_glenohumeral_extension         = obj.right_glenohumeral_extension;
        var right_glenohumeral_abduction         = obj.right_glenohumeral_abduction;
        var right_glenohumeral_internal_rotation = obj.right_glenohumeral_internal_rotation;
        var right_glenohumeral_external_rotation = obj.right_glenohumeral_external_rotation;
        var right_elbow_flexion                  = obj.right_elbow_flexion;
        var right_elbow_extension                = obj.right_elbow_extension;
        var right_wrist_flexion                  = obj.right_wrist_flexion;
        var right_wrist_extension                = obj.right_wrist_extension;
        var right_wrist_radial_deviation         = obj.right_wrist_radial_deviation;
        var right_wrist_ulnar_deviation          = obj.right_wrist_ulnar_deviation;
        var right_thumb_flexion                  = obj.right_thumb_flexion;
        var right_thumb_extension                = obj.right_thumb_extension;
        var right_thumb_abduction                = obj.right_thumb_abduction;
        var right_thumb_adduction                = obj.right_thumb_adduction;

        var left_1st_toe_flexion                = obj.left_1st_toe_flexion;
        var left_1st_toe_extension              = obj.left_1st_toe_extension;
        var left_ankle_dorsiflexion             = obj.left_ankle_dorsiflexion;
        var left_ankle_plantarflexion           = obj.left_ankle_plantarflexion;
        var left_ankle_eversion                 = obj.left_ankle_eversion;
        var left_ankle_inversion                = obj.left_ankle_inversion;
        var left_knee_extension                 = obj.left_knee_extension;
        var left_knee_flexion                   = obj.left_knee_flexion;
        var left_hip_extension                  = obj.left_hip_extension;
        var left_hip_flexion                    = obj.left_hip_flexion;
        var left_hip_abduction                  = obj.left_hip_abduction;
        var left_hip_adduction                  = obj.left_hip_adduction;
        var left_glenohumeral_flexion           = obj.left_glenohumeral_flexion;
        var left_glenohumeral_extension         = obj.left_glenohumeral_extension;
        var left_glenohumeral_abduction         = obj.left_glenohumeral_abduction;
        var left_glenohumeral_internal_rotation = obj.left_glenohumeral_internal_rotation;
        var left_glenohumeral_external_rotation = obj.left_glenohumeral_external_rotation;
        var left_elbow_flexion                  = obj.left_elbow_flexion;
        var left_elbow_extension                = obj.left_elbow_extension;
        var left_wrist_flexion                  = obj.left_wrist_flexion;
        var left_wrist_extension                = obj.left_wrist_extension;
        var left_wrist_radial_deviation         = obj.left_wrist_radial_deviation;
        var left_wrist_ulnar_deviation          = obj.left_wrist_ulnar_deviation;
        var left_thumb_flexion                  = obj.left_thumb_flexion;
        var left_thumb_extension                = obj.left_thumb_extension;
        var left_thumb_abduction                = obj.left_thumb_abduction;
        var left_thumb_adduction                = obj.left_thumb_adduction;

        var left_hip_internal_rotation          = obj.left_hip_internal_rotation;
        var right_hip_internal_rotation         = obj.right_hip_internal_rotation;
        var left_hip_external_rotation          = obj.left_hip_external_rotation;
        var right_hip_external_rotation         = obj.right_hip_external_rotation;
        
        this.setUserFormData(right_1st_toe_flexion, right_1st_toe_extension, right_ankle_dorsiflexion, right_ankle_plantarflexion, right_ankle_eversion, right_ankle_inversion, right_knee_extension, right_knee_flexion, right_hip_extension, right_hip_flexion, right_hip_abduction, right_hip_adduction, right_glenohumeral_flexion, right_glenohumeral_extension, right_glenohumeral_abduction, right_glenohumeral_internal_rotation, right_glenohumeral_external_rotation, right_elbow_flexion, right_elbow_extension, right_wrist_flexion, right_wrist_extension, right_wrist_radial_deviation, right_wrist_ulnar_deviation, right_thumb_flexion, right_thumb_extension, right_thumb_abduction, right_thumb_adduction, left_1st_toe_flexion, left_1st_toe_extension, left_ankle_dorsiflexion, left_ankle_plantarflexion, left_ankle_eversion, left_ankle_inversion, left_knee_extension, left_knee_flexion, left_hip_extension, left_hip_flexion, left_hip_abduction, left_hip_adduction, left_glenohumeral_flexion, left_glenohumeral_extension, left_glenohumeral_abduction, left_glenohumeral_internal_rotation, left_glenohumeral_external_rotation, left_elbow_flexion, left_elbow_extension, left_wrist_flexion, left_wrist_extension, left_wrist_radial_deviation, left_wrist_ulnar_deviation, left_thumb_flexion, left_thumb_extension, left_thumb_abduction, left_thumb_adduction, left_hip_internal_rotation, right_hip_internal_rotation, left_hip_external_rotation, right_hip_external_rotation);
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/JointROMForm.js